/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Intakeeventsone2Inputs */

const en_intakeeventsone2 = /** @type {(inputs: Intakeeventsone2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 event`)
};

const pt_intakeeventsone2 = /** @type {(inputs: Intakeeventsone2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 evento`)
};

/**
* | output |
* | --- |
* | "1 event" |
*
* @param {Intakeeventsone2Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const intakeeventsone2 = /** @type {((inputs?: Intakeeventsone2Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Intakeeventsone2Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_intakeeventsone2(inputs)
	return pt_intakeeventsone2(inputs)
});
export { intakeeventsone2 as "intakeEventsOne" }